import instoreAddNewCardModal from './instoreAddNewCardModal';

export default instoreAddNewCardModal;
